export default "__VITE_ASSET__BEHYym2g__"